// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"customer-videos_wrapper__jS3qD"};